import ExcelJS from 'exceljs';

const exportExcelFile = (excelFormatData, fileName, columnConfig) => {
  if (excelFormatData && fileName && columnConfig) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('My Sheet');
    sheet.properties.defaultRowHeight = 20;
    const totalHeaderWidth = columnConfig.reduce((total, { width }) => total + width, 0);

    sheet.mergeCells(`A1:${String.fromCharCode(64 + columnConfig.length)}1`);
    const headerCell = sheet.getCell('A1');
    headerCell.value = 'AGManager™';
    headerCell.alignment = { horizontal: 'center' };
    headerCell.font = { size: 20, bold: true };
    headerCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'E6B471' },
    };
    sheet.getColumn('A').width = totalHeaderWidth;

    // Find the index of the Colour column, if it exists
    const colourColumnIndex = columnConfig.findIndex(({ key }) => key === 'Colour') + 1;

    columnConfig.forEach(({ header, key, width }, index) => {
      const cell = sheet.getRow(2).getCell(index + 1);
      cell.value = header;
      sheet.getColumn(index + 1).key = key;
      sheet.getColumn(index + 1).width = width;
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' },
      };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
    });

    excelFormatData?.bioplusUsers?.forEach((product, rowIndex) => {
      const rowData = columnConfig.map(({ key }) => product[key]);
      const row = sheet.addRow(rowData);

      // Set row background color for even/odd rows
      const defaultRowColor = rowIndex % 2 === 0 ? 'FFFFFF' : 'F2F2F2';
      row.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: defaultRowColor },
        };
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
      });

      // If Colour column exists and has a value, set background color for only that cell
      if (colourColumnIndex && product.Colour) {
        const colourCell = row.getCell(colourColumnIndex);
        const cellColor = product.Colour.replace('#', '');
        colourCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: cellColor },
        };
      }
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }
};

export { exportExcelFile };
